import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";

const LINKS = [
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/temper-profile", label: "Temper Profile" },
  { to: "/contact", label: "Contact" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <>
      <header
        data-testid="site-nav"
        className="fixed inset-x-0 top-0 z-50 border-b border-line bg-paper/85 backdrop-blur-xl"
      >
        <div className="mx-auto flex h-16 max-w-[1440px] items-center justify-between px-6 md:h-20 md:px-10">
          <Link to="/" data-testid="nav-home-link" aria-label="TEMPER Leadership home">
            <Logo />
          </Link>
          <nav className="hidden items-center gap-8 md:flex">
            {LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`nav-${l.label.toLowerCase().replace(" ", "-")}-link`}
                className={({ isActive }) =>
                  `font-mono text-[11px] uppercase tracking-[0.2em] transition-colors duration-300 hover:text-ember ${
                    isActive ? "text-ember" : "text-ink/70"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/temper-profile"
              data-testid="nav-cta"
              className="bg-ember px-5 py-3 font-mono text-[11px] uppercase tracking-[0.2em] text-paper transition-colors duration-300 hover:bg-ink"
            >
              Take the Profile
            </Link>
          </nav>
          <button
            data-testid="nav-mobile-toggle"
            className="-mr-2 p-2 md:hidden"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </header>
      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="mobile-menu"
            className="fixed inset-0 z-40 flex flex-col justify-center bg-paper px-8"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <nav className="flex flex-col gap-3">
              {[{ to: "/", label: "Home" }, ...LINKS].map((l, i) => (
                <motion.span
                  key={l.to}
                  className="block overflow-hidden"
                  initial={{ y: "110%" }}
                  animate={{ y: 0 }}
                  transition={{ delay: 0.08 + i * 0.06, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
                >
                  <Link
                    to={l.to}
                    data-testid={`mobile-menu-${l.label.toLowerCase().replace(" ", "-")}-link`}
                    className="font-display text-5xl font-extrabold tracking-tight text-ink"
                  >
                    {l.label}
                  </Link>
                </motion.span>
              ))}
            </nav>
            <Link
              to="/temper-profile"
              data-testid="mobile-menu-cta"
              className="btn-ember mt-12 self-start font-mono text-[11px] uppercase tracking-[0.2em]"
            >
              Take the TEMPER Profile
            </Link>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
